import React, { useCallback } from 'react'
import PrivateFooterSectionContainer from '../containers/FooterSection/PrivateFooter.container'
import HeaderSectionContainer from '../containers/HeaderSection/HeaderSection.container'
import AuthorizationProvider from '../containers/AuthorizationProvider/AuthorizationProvider.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import ProtectByProfile from '../components/Security/ProtectByProfile'
import NotFoundPage from './NotFound'
import HeadingSectionContainer from '../containers/HeadingSection/HeadingSection.container'
import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../config/settings/environment'
import NotAllowedContainer from '../containers/NotAllowed/NotAllowed'

/**
 * Not Allowed page.
 */
const NotAllowed = () => {
  const title = ''
  const subtitle = ''

  const breadcrumbs = useCallback(() => {
    return [
      {
        children: 'Escritorio',
        to: `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`,
        type: 'external',
        variant: 'link',
        onClick: () => handleClickHome()
      },
      {
        children: 'Listado de participantes',
        variant: 'text'
      }
    ]
  }, [])

  const handleClickHome = () => {
    const url = `${REACT_APP_MERCADO_PUBLICO_BASE_URL}/Portal/Modules/Menu/Menu.aspx`
    location.href = url
  }

  return (
    <AuthorizationProvider>
      <ProtectByProfile rule={userType => userType === 'Comprador'} fallback={() => <NotFoundPage />}>
        <BrandLayout
          featured={<HeadingSectionContainer breadcrumbs={breadcrumbs()} title={title} subtitle={subtitle} />}
          footer={<PrivateFooterSectionContainer />}
          header={<HeaderSectionContainer showBackButton />}
        >
          <NotAllowedContainer />
        </BrandLayout>
      </ProtectByProfile>
    </AuthorizationProvider>
  )
}

export default NotAllowed
